document.querySelectorAll('.quickshop:not(.hidden) .rc-radio').forEach(function(radio) {
  radio.addEventListener('click', function() {
    document.querySelectorAll('.quickshop:not(.hidden) .price-item--regular').forEach(function(item) {
      item.classList.add('hidden');
    });
  });
});

// Update this for quickshop subscription loader.
window.addEventListener('DOMContentLoaded', () => {
  var labels = document.querySelectorAll('.inside-modal label');
  labels.forEach(label => {
    label.addEventListener('click', () => {
      var labelText = label.innerHTML;
      if (labelText.indexOf('Single') >= 0) {
        if (document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper')) {
          document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper').style.display = 'none';
        }
      } else {
        var prodId = label.getAttribute('for');
        var myArray = prodId.split('-');
        let prodIdz = myArray[0];
        var widget = document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper');
        if (widget) {
          document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper').style.display = 'block';
          return;
        }
        var config = {
          productId: parseInt(prodIdz),
          injectionParent: '.quickshop:not(.hidden)  .subscription__widget', // The node that will have the widget injected in
          injectionMethod: 'prepend', // How will the widget be injected
          selectors: {
            price: ['.price-item--regular'], // the selectors that will be updated based on subscription
            variant: ['.inside-modal input']
          }
        };
        window.ReChargeWidget.createWidget(config);
        setTimeout(function () {
          var el = document.querySelector('.quickshop:not(.hidden) .rc-container-wrapper');
          if (el) {
            el.style.display = 'block';
          }
        }, 100);
      }
    });
  });
});


